import React, { useRef } from "react";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import styles from "./products-slider.scss";
import Slider from "../slider/slider";

function ProductsSlider(props) {
  const {
    children,
    heading,
    subHeading,
    // backgroundColor,
    backgroundImage,
    showViewBtn,
    viewBtnHandler,
  } = props;

  return (
    <div className={styles["slider-container"]}>
      {(heading || subHeading || showViewBtn) && (
        <div className={styles["header"]}>
          <div className={styles["heading-section"]}>
            <div className={styles["heading_section_and_btn"]}>
              <div className={styles["heading_and_sub_heading"]}>
                <div className={styles["heading"]}>{heading}</div>
                <div className={styles["sub-heading"]}>{subHeading}</div>
              </div>

              {showViewBtn && (
                <button className={styles["view-btn"]} onClick={viewBtnHandler}>
                  查看全部
                </button>
              )}
            </div>
            {backgroundImage && (
              <img src={backgroundImage} className={styles["bg-img-sm"]} />
            )}
          </div>
        </div>
      )}
      <div className={styles["card_view"]}>
        {backgroundImage && (
          <div className={styles["desktop_view_img"]}>
            {backgroundImage && (
              <img src={backgroundImage} className={styles["bg-img2"]} />
            )}
          </div>
        )}
        <Slider isBgImg={!!backgroundImage}>{children}</Slider>
      </div>
    </div>
  );
}

ProductsSlider.defaultProps = {
  children: [],
  heading: "",
  subHeading: "",
  backgroundColor: "",
  backgroundImage: "",
  showViewBtn: false,
};

ProductsSlider.propTypes = {
  children: PropTypes.array,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  showViewBtn: PropTypes.bool,
};

export default ProductsSlider;
